// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dmuodoT5AKQXZ2o0z7MV {
  background: #ffffff;
  height: 100vh;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #e8e8e8;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}

.SA8eLT8oQSCP1FsfPV1c {
  padding: 16px;
  border-bottom: 1px solid #e8e8e8;
  background: #fafafa;
  position: relative;
  flex-shrink: 0;
}

.WrX61guO15pvsGpY_a1T {
  width: 100%;
  height: 40px;
  border-radius: 6px;
  background: #1890ff;
  border: none;
  box-shadow: 0 2px 4px rgba(24, 144, 255, 0.15);
  transition: all 0.2s ease;
}

.WrX61guO15pvsGpY_a1T:hover {
  background: #096dd9;
  box-shadow: 0 4px 8px rgba(24, 144, 255, 0.2);
}

.WrX61guO15pvsGpY_a1T:active {
  transform: translateY(1px);
}

.W2Gthzayu09bqzJkuLBM {
  flex: 1;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}

.W2Gthzayu09bqzJkuLBM::-webkit-scrollbar {
  width: 8px;
}

.W2Gthzayu09bqzJkuLBM::-webkit-scrollbar-track {
  background: #f0f0f0;
  border-radius: 4px;
}

.W2Gthzayu09bqzJkuLBM::-webkit-scrollbar-thumb {
  background: #bfbfbf;
  border-radius: 4px;
  border: 1px solid #f0f0f0;
}

.W2Gthzayu09bqzJkuLBM::-webkit-scrollbar-thumb:hover {
  background: #999;
}

.NywswRC3WN7V6a40_cn4 {
  background: #fff;
  border-radius: 8px;
  padding: 12px;
  border: 1px solid #e8e8e8;
  transition: border-color 0.2s ease;
  flex-shrink: 0;
}

.NywswRC3WN7V6a40_cn4:hover {
  border-color: #d9d9d9;
}

.ghlebsPW_4HAEPc3yrsi {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  padding-bottom: 6px;
  border-bottom: 1px solid #f0f0f0;
}

.UOwNiIvY8NKAHNH0zkNu {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: #404040;
}

.UJV4rkndOdRldMyhUPUF {
  font-size: 14px;
  color: #8c8c8c;
}

.P8nwrio6m34Vm96iLMtC {
  background: #f0f0f0;
  color: #666;
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 8px;
  font-weight: 500;
}

.BrnNoPfBWtXR4nDLeWET {
  text-align: center;
  padding: 20px 12px;
  color: #8c8c8c;
}

.O3uLa38p7HcETVmlCejk {
  font-size: 20px;
  margin-bottom: 6px;
  opacity: 0.5;
}

.G1jZ8yYsR8BkNNFPrfRX {
  font-size: 12px;
  line-height: 1.4;
}

.PEZ0bVzy5tmy_OOHUIqn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 8px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 2px;
  border: 1px solid transparent;
}

.PEZ0bVzy5tmy_OOHUIqn:hover {
  background: #f8f8f8;
  border-color: #e8e8e8;
}

.PEZ0bVzy5tmy_OOHUIqn:active {
  background: #f0f0f0;
}

.Tcak6qYx940yLyUA_IIt {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1;
  min-width: 0;
}

.E3m_n6UoaiiaFA5f5eM7 {
  font-size: 12px;
  color: #404040;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.LLL0i9AAY_QlWN4iuFog {
  display: flex;
  align-items: center;
  gap: 2px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.PEZ0bVzy5tmy_OOHUIqn:hover .LLL0i9AAY_QlWN4iuFog {
  opacity: 1;
}

.CWYt6lNUBZNzcIepnDiI {
  width: 18px;
  height: 18px;
  border-radius: 3px;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.CWYt6lNUBZNzcIepnDiI:hover {
  background: #f0f0f0;
  color: #1890ff;
}

.wqgw_OcwVfs2W1hDSA9q.VJ3blEuhXUEQApJu3OKD {
  color: #faad14;
}

.ywyFhVS0LvGQZWSm1kLN {
  max-height: 140px;
  overflow-y: auto;
  min-height: 60px;
}

.ywyFhVS0LvGQZWSm1kLN::-webkit-scrollbar {
  width: 6px;
}

.ywyFhVS0LvGQZWSm1kLN::-webkit-scrollbar-track {
  background: #f8f8f8;
  border-radius: 3px;
}

.ywyFhVS0LvGQZWSm1kLN::-webkit-scrollbar-thumb {
  background: #d9d9d9;
  border-radius: 3px;
}

.ywyFhVS0LvGQZWSm1kLN::-webkit-scrollbar-thumb:hover {
  background: #bfbfbf;
}

.JZyyRz1SQ0V2quDxSCJA {
  flex: 1;
  min-height: 200px;
  overflow-y: auto !important;
  overflow-x: hidden;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  padding: 4px;
}

.JZyyRz1SQ0V2quDxSCJA::-webkit-scrollbar {
  width: 8px;
}

.JZyyRz1SQ0V2quDxSCJA::-webkit-scrollbar-track {
  background: #f8f8f8;
  border-radius: 4px;
}

.JZyyRz1SQ0V2quDxSCJA::-webkit-scrollbar-thumb {
  background: #d9d9d9;
  border-radius: 4px;
  border: 1px solid #f0f0f0;
}

.JZyyRz1SQ0V2quDxSCJA::-webkit-scrollbar-thumb:hover {
  background: #bfbfbf;
}

.ck9BdeMw29gMTyw6jQpR {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px 15px;
  color: #8c8c8c;
}

.Qtl_pXMtIN028zawECsS {
  font-size: 20px;
  margin-bottom: 8px;
  animation: jAE0CQ41rRVV8fXVuCE3 1s linear infinite;
}

@keyframes jAE0CQ41rRVV8fXVuCE3 {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* Custom Tree Styles */
.JZyyRz1SQ0V2quDxSCJA .ant-tree {
  background: transparent !important;
  color: inherit;
  overflow: visible !important;
  height: auto !important;
}

.JZyyRz1SQ0V2quDxSCJA .ant-tree-node-content-wrapper {
  border-radius: 4px;
  transition: all 0.2s ease;
  padding: 3px 6px;
  margin: 1px 0;
}

.JZyyRz1SQ0V2quDxSCJA .ant-tree-node-content-wrapper:hover {
  background-color: #f8f8f8 !important;
}

.JZyyRz1SQ0V2quDxSCJA .ant-tree-node-content-wrapper.ant-tree-node-selected {
  background-color: #e6f7ff !important;
  border: 1px solid #91d5ff;
}

.JZyyRz1SQ0V2quDxSCJA .ant-tree-indent-unit {
  width: 18px;
}

.JZyyRz1SQ0V2quDxSCJA .ant-tree-switcher {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8c8c8c;
  transition: color 0.2s ease;
}

.JZyyRz1SQ0V2quDxSCJA .ant-tree-switcher:hover {
  color: #1890ff;
}

.JZyyRz1SQ0V2quDxSCJA .ant-tree-switcher-icon {
  font-size: 10px;
}

.JZyyRz1SQ0V2quDxSCJA .ant-tree-title {
  width: 100%;
}

/* Tree Section Card - specific styles for the tree section */
.aE99NTSeYGWq5M68VjZ6 {
  background: #fff;
  border-radius: 8px;
  padding: 12px;
  border: 1px solid #e8e8e8;
  transition: border-color 0.2s ease;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
}

.aE99NTSeYGWq5M68VjZ6:hover {
  border-color: #d9d9d9;
}

/* Collapsed state adjustments */
.dmuodoT5AKQXZ2o0z7MV .ant-layout-sider-collapsed {
  .SA8eLT8oQSCP1FsfPV1c {
    padding: 8px;
  }
  
  .W2Gthzayu09bqzJkuLBM {
    display: none;
  }
}

/* Responsive design */
@media (max-width: 768px) {
  .dmuodoT5AKQXZ2o0z7MV {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1000;
    box-shadow: 4px 0 24px rgba(0, 0, 0, 0.15);
  }
}

/* Small height screens */
@media (max-height: 600px) {
  .W2Gthzayu09bqzJkuLBM {
    gap: 8px;
    padding: 8px;
  }
  
  .ywyFhVS0LvGQZWSm1kLN {
    max-height: 100px;
    min-height: 40px;
  }
  
  .JZyyRz1SQ0V2quDxSCJA {
    min-height: 150px;
  }
  
  .aE99NTSeYGWq5M68VjZ6 {
    min-height: 200px;
  }
  
  .SA8eLT8oQSCP1FsfPV1c {
    padding: 12px;
  }
  
  .NywswRC3WN7V6a40_cn4 {
    padding: 8px;
  }
  
  .ghlebsPW_4HAEPc3yrsi {
    margin-bottom: 6px;
    padding-bottom: 4px;
  }
}

/* Very small height screens */
@media (max-height: 480px) {
  .ywyFhVS0LvGQZWSm1kLN {
    max-height: 80px;
    min-height: 30px;
  }
  
  .JZyyRz1SQ0V2quDxSCJA {
    min-height: 120px;
  }
  
  .aE99NTSeYGWq5M68VjZ6 {
    min-height: 150px;
  }
  
  .W2Gthzayu09bqzJkuLBM {
    gap: 6px;
    padding: 6px;
  }
  
  .SA8eLT8oQSCP1FsfPV1c {
    padding: 8px;
  }
  
  .NywswRC3WN7V6a40_cn4 {
    padding: 6px;
  }
}

/* Smooth transitions */
.PEZ0bVzy5tmy_OOHUIqn, .CWYt6lNUBZNzcIepnDiI, .NywswRC3WN7V6a40_cn4 {
  transition: all 0.2s ease;
}

/* Focus styles for accessibility */
.CWYt6lNUBZNzcIepnDiI:focus {
  outline: 2px solid #1890ff;
  outline-offset: 1px;
}

.PEZ0bVzy5tmy_OOHUIqn:focus-within {
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.G3dthiaQz1RwlNts3dF9 {
  height: 8px;
  background: linear-gradient(to bottom, transparent 2px, #f0f0f0 2px, #f0f0f0 6px, transparent 6px);
  cursor: ns-resize;
  position: relative;
  flex-shrink: 0;
  margin: 2px 0;
  border-radius: 1px;
  transition: background 0.2s ease;
}

.G3dthiaQz1RwlNts3dF9:hover {
  background: linear-gradient(to bottom, transparent 2px, #1890ff 2px, #1890ff 6px, transparent 6px);
}

.G3dthiaQz1RwlNts3dF9::before {
  content: '';
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 24px;
  height: 4px;
  background: #d9d9d9;
  border-radius: 2px;
  transition: background 0.2s ease;
}

.G3dthiaQz1RwlNts3dF9:hover::before {
  background: #1890ff;
}

.G3dthiaQz1RwlNts3dF9::after {
  content: '';
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 16px;
  height: 2px;
  background: #8c8c8c;
  border-radius: 1px;
  transition: background 0.2s ease;
}

.G3dthiaQz1RwlNts3dF9:hover::after {
  background: #ffffff;
} `, "",{"version":3,"sources":["webpack://./src/components/SettingsWindow/StatusSidebar/StatusSidebar.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,OAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,OAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kDAAkC;AACpC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA,uBAAuB;AACvB;EACE,kCAAkC;EAClC,cAAc;EACd,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA,6DAA6D;AAC7D;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;EACE;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;IACf,OAAO;IACP,MAAM;IACN,aAAa;IACb,0CAA0C;EAC5C;AACF;;AAEA,yBAAyB;AACzB;EACE;IACE,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,kGAAkG;EAClG,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,kGAAkG;AACpG;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".sidebar {\n  background: #ffffff;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  border-right: 1px solid #e8e8e8;\n  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.04);\n  overflow: hidden;\n}\n\n.headerSection {\n  padding: 16px;\n  border-bottom: 1px solid #e8e8e8;\n  background: #fafafa;\n  position: relative;\n  flex-shrink: 0;\n}\n\n.syncButton {\n  width: 100%;\n  height: 40px;\n  border-radius: 6px;\n  background: #1890ff;\n  border: none;\n  box-shadow: 0 2px 4px rgba(24, 144, 255, 0.15);\n  transition: all 0.2s ease;\n}\n\n.syncButton:hover {\n  background: #096dd9;\n  box-shadow: 0 4px 8px rgba(24, 144, 255, 0.2);\n}\n\n.syncButton:active {\n  transform: translateY(1px);\n}\n\n.contentArea {\n  flex: 1;\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.contentArea::-webkit-scrollbar {\n  width: 8px;\n}\n\n.contentArea::-webkit-scrollbar-track {\n  background: #f0f0f0;\n  border-radius: 4px;\n}\n\n.contentArea::-webkit-scrollbar-thumb {\n  background: #bfbfbf;\n  border-radius: 4px;\n  border: 1px solid #f0f0f0;\n}\n\n.contentArea::-webkit-scrollbar-thumb:hover {\n  background: #999;\n}\n\n.sectionCard {\n  background: #fff;\n  border-radius: 8px;\n  padding: 12px;\n  border: 1px solid #e8e8e8;\n  transition: border-color 0.2s ease;\n  flex-shrink: 0;\n}\n\n.sectionCard:hover {\n  border-color: #d9d9d9;\n}\n\n.sectionHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n  padding-bottom: 6px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.sectionTitle {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: #404040;\n}\n\n.sectionIcon {\n  font-size: 14px;\n  color: #8c8c8c;\n}\n\n.sectionCount {\n  background: #f0f0f0;\n  color: #666;\n  font-size: 11px;\n  padding: 2px 6px;\n  border-radius: 8px;\n  font-weight: 500;\n}\n\n.emptyState {\n  text-align: center;\n  padding: 20px 12px;\n  color: #8c8c8c;\n}\n\n.emptyIcon {\n  font-size: 20px;\n  margin-bottom: 6px;\n  opacity: 0.5;\n}\n\n.emptyText {\n  font-size: 12px;\n  line-height: 1.4;\n}\n\n.listItem {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 6px 8px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  margin-bottom: 2px;\n  border: 1px solid transparent;\n}\n\n.listItem:hover {\n  background: #f8f8f8;\n  border-color: #e8e8e8;\n}\n\n.listItem:active {\n  background: #f0f0f0;\n}\n\n.listItemContent {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex: 1;\n  min-width: 0;\n}\n\n.listItemText {\n  font-size: 12px;\n  color: #404040;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.listItemActions {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.listItem:hover .listItemActions {\n  opacity: 1;\n}\n\n.actionButton {\n  width: 18px;\n  height: 18px;\n  border-radius: 3px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.actionButton:hover {\n  background: #f0f0f0;\n  color: #1890ff;\n}\n\n.favoriteButton.active {\n  color: #faad14;\n}\n\n.fixedHeightSection {\n  max-height: 140px;\n  overflow-y: auto;\n  min-height: 60px;\n}\n\n.fixedHeightSection::-webkit-scrollbar {\n  width: 6px;\n}\n\n.fixedHeightSection::-webkit-scrollbar-track {\n  background: #f8f8f8;\n  border-radius: 3px;\n}\n\n.fixedHeightSection::-webkit-scrollbar-thumb {\n  background: #d9d9d9;\n  border-radius: 3px;\n}\n\n.fixedHeightSection::-webkit-scrollbar-thumb:hover {\n  background: #bfbfbf;\n}\n\n.treeContainer {\n  flex: 1;\n  min-height: 200px;\n  overflow-y: auto !important;\n  overflow-x: hidden;\n  border: 1px solid #f0f0f0;\n  border-radius: 4px;\n  padding: 4px;\n}\n\n.treeContainer::-webkit-scrollbar {\n  width: 8px;\n}\n\n.treeContainer::-webkit-scrollbar-track {\n  background: #f8f8f8;\n  border-radius: 4px;\n}\n\n.treeContainer::-webkit-scrollbar-thumb {\n  background: #d9d9d9;\n  border-radius: 4px;\n  border: 1px solid #f0f0f0;\n}\n\n.treeContainer::-webkit-scrollbar-thumb:hover {\n  background: #bfbfbf;\n}\n\n.loadingState {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 30px 15px;\n  color: #8c8c8c;\n}\n\n.loadingIcon {\n  font-size: 20px;\n  margin-bottom: 8px;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n/* Custom Tree Styles */\n.treeContainer :global(.ant-tree) {\n  background: transparent !important;\n  color: inherit;\n  overflow: visible !important;\n  height: auto !important;\n}\n\n.treeContainer :global(.ant-tree-node-content-wrapper) {\n  border-radius: 4px;\n  transition: all 0.2s ease;\n  padding: 3px 6px;\n  margin: 1px 0;\n}\n\n.treeContainer :global(.ant-tree-node-content-wrapper:hover) {\n  background-color: #f8f8f8 !important;\n}\n\n.treeContainer :global(.ant-tree-node-content-wrapper.ant-tree-node-selected) {\n  background-color: #e6f7ff !important;\n  border: 1px solid #91d5ff;\n}\n\n.treeContainer :global(.ant-tree-indent-unit) {\n  width: 18px;\n}\n\n.treeContainer :global(.ant-tree-switcher) {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #8c8c8c;\n  transition: color 0.2s ease;\n}\n\n.treeContainer :global(.ant-tree-switcher:hover) {\n  color: #1890ff;\n}\n\n.treeContainer :global(.ant-tree-switcher-icon) {\n  font-size: 10px;\n}\n\n.treeContainer :global(.ant-tree-title) {\n  width: 100%;\n}\n\n/* Tree Section Card - specific styles for the tree section */\n.treeSectionCard {\n  background: #fff;\n  border-radius: 8px;\n  padding: 12px;\n  border: 1px solid #e8e8e8;\n  transition: border-color 0.2s ease;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  position: relative;\n}\n\n.treeSectionCard:hover {\n  border-color: #d9d9d9;\n}\n\n/* Collapsed state adjustments */\n.sidebar :global(.ant-layout-sider-collapsed) {\n  .headerSection {\n    padding: 8px;\n  }\n  \n  .contentArea {\n    display: none;\n  }\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .sidebar {\n    position: fixed;\n    left: 0;\n    top: 0;\n    z-index: 1000;\n    box-shadow: 4px 0 24px rgba(0, 0, 0, 0.15);\n  }\n}\n\n/* Small height screens */\n@media (max-height: 600px) {\n  .contentArea {\n    gap: 8px;\n    padding: 8px;\n  }\n  \n  .fixedHeightSection {\n    max-height: 100px;\n    min-height: 40px;\n  }\n  \n  .treeContainer {\n    min-height: 150px;\n  }\n  \n  .treeSectionCard {\n    min-height: 200px;\n  }\n  \n  .headerSection {\n    padding: 12px;\n  }\n  \n  .sectionCard {\n    padding: 8px;\n  }\n  \n  .sectionHeader {\n    margin-bottom: 6px;\n    padding-bottom: 4px;\n  }\n}\n\n/* Very small height screens */\n@media (max-height: 480px) {\n  .fixedHeightSection {\n    max-height: 80px;\n    min-height: 30px;\n  }\n  \n  .treeContainer {\n    min-height: 120px;\n  }\n  \n  .treeSectionCard {\n    min-height: 150px;\n  }\n  \n  .contentArea {\n    gap: 6px;\n    padding: 6px;\n  }\n  \n  .headerSection {\n    padding: 8px;\n  }\n  \n  .sectionCard {\n    padding: 6px;\n  }\n}\n\n/* Smooth transitions */\n.listItem, .actionButton, .sectionCard {\n  transition: all 0.2s ease;\n}\n\n/* Focus styles for accessibility */\n.actionButton:focus {\n  outline: 2px solid #1890ff;\n  outline-offset: 1px;\n}\n\n.listItem:focus-within {\n  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);\n}\n\n.resizeHandle {\n  height: 8px;\n  background: linear-gradient(to bottom, transparent 2px, #f0f0f0 2px, #f0f0f0 6px, transparent 6px);\n  cursor: ns-resize;\n  position: relative;\n  flex-shrink: 0;\n  margin: 2px 0;\n  border-radius: 1px;\n  transition: background 0.2s ease;\n}\n\n.resizeHandle:hover {\n  background: linear-gradient(to bottom, transparent 2px, #1890ff 2px, #1890ff 6px, transparent 6px);\n}\n\n.resizeHandle::before {\n  content: '';\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 24px;\n  height: 4px;\n  background: #d9d9d9;\n  border-radius: 2px;\n  transition: background 0.2s ease;\n}\n\n.resizeHandle:hover::before {\n  background: #1890ff;\n}\n\n.resizeHandle::after {\n  content: '';\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 16px;\n  height: 2px;\n  background: #8c8c8c;\n  border-radius: 1px;\n  transition: background 0.2s ease;\n}\n\n.resizeHandle:hover::after {\n  background: #ffffff;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar": `dmuodoT5AKQXZ2o0z7MV`,
	"headerSection": `SA8eLT8oQSCP1FsfPV1c`,
	"syncButton": `WrX61guO15pvsGpY_a1T`,
	"contentArea": `W2Gthzayu09bqzJkuLBM`,
	"sectionCard": `NywswRC3WN7V6a40_cn4`,
	"sectionHeader": `ghlebsPW_4HAEPc3yrsi`,
	"sectionTitle": `UOwNiIvY8NKAHNH0zkNu`,
	"sectionIcon": `UJV4rkndOdRldMyhUPUF`,
	"sectionCount": `P8nwrio6m34Vm96iLMtC`,
	"emptyState": `BrnNoPfBWtXR4nDLeWET`,
	"emptyIcon": `O3uLa38p7HcETVmlCejk`,
	"emptyText": `G1jZ8yYsR8BkNNFPrfRX`,
	"listItem": `PEZ0bVzy5tmy_OOHUIqn`,
	"listItemContent": `Tcak6qYx940yLyUA_IIt`,
	"listItemText": `E3m_n6UoaiiaFA5f5eM7`,
	"listItemActions": `LLL0i9AAY_QlWN4iuFog`,
	"actionButton": `CWYt6lNUBZNzcIepnDiI`,
	"favoriteButton": `wqgw_OcwVfs2W1hDSA9q`,
	"active": `VJ3blEuhXUEQApJu3OKD`,
	"fixedHeightSection": `ywyFhVS0LvGQZWSm1kLN`,
	"treeContainer": `JZyyRz1SQ0V2quDxSCJA`,
	"loadingState": `ck9BdeMw29gMTyw6jQpR`,
	"loadingIcon": `Qtl_pXMtIN028zawECsS`,
	"spin": `jAE0CQ41rRVV8fXVuCE3`,
	"treeSectionCard": `aE99NTSeYGWq5M68VjZ6`,
	"resizeHandle": `G3dthiaQz1RwlNts3dF9`
};
export default ___CSS_LOADER_EXPORT___;
